<div
  *ngIf="!isOkButtonPressed"
  class="form-information-wrapper vo-link-inside vo-info-box--warning my-15 w-100"
  [ngClass]="{ exclamation: decoration == 'exclamation-mark', question: decoration == 'question-mark' }"
>
  <div
    class="message-container bo-info-text vo-body-regular-14"
    (click)="clickEvent.emit($event)"
    [innerHTML]="shouldNotLocalize ? message : (message | localizeLabel)"
  ></div>

  <div *ngIf="includeOkButton">
    <div class="text-right">
      <button
        class="primary-button vo-secondary-button-1 mt-15"
        (click)="buttonClickEvent.emit($event); isOkButtonPressed = true"
        [disabled]="buttonDisabled"
        [innerHtml]="buttonLabel || (referenceDataLabels.OkText | localizeLabel)"
      ></button>
    </div>
  </div>
</div>
